import * as _ from 'underscore';
import { DevicePickerBar } from '../../app/content/devicePreview/deviceBar/DevicePickerBar';
import { UserAgentSupport } from '../../common/utilities/UserAgentSupport';
import { DeviceType } from '../models/DeviceType';
import { IViewBase, IViewDetailInfo, IViewInfo } from '../models/IViewInfo';
import { IViz, VizType } from '../models/Viz';
import { Module } from '../Module';
import { Dashboards } from '../resources/Dashboards';
import { Views } from '../resources/Views';
import { DevicePreviewService } from '../services/DevicePreviewService';
import { ErrorState } from '../services/ErrorState';
import { ServerService } from '../services/ServerService';
import { VizService } from '../services/VizService';

export interface IVizProperties {
  view?: IViewBase;
}

export interface IVizPreviewScope extends ng.IScope {
  viz: IViz;
  vizProps: IVizProperties;
  devicePickerBarProps: DevicePickerBar.Props;
  hasError: () => boolean;
  isTouch: () => boolean;
  onVizInitialized: () => void;
  vizInitialized: boolean;
  vizPath: string;
}

export class VizPreviewCtrl {

  public static $inject = [
    '$scope',
    '$q',
    'ErrorState',
    'DevicePreviewService',
    'ServerService',
    'VizService',
    'Views',
    'Dashboards'
  ];

  private hasError: boolean;
  private hasViewError: boolean = false;

  constructor(
    private $scope: IVizPreviewScope,
    private $q: ng.IQService,
            errorState: ErrorState,
    private devicePreviewService: DevicePreviewService,
    private server: ServerService,
            vizService: VizService,
    private views: Views,
    private dashboards: Dashboards
  ) {
    if (!devicePreviewService.isEnabled()) {
      errorState.go({
        detailsLocKey: 'pageDoesNotExist',
        redirectState: 'main.site.content.site.projects',
        redirectLocKey: 'backToContent'
      });
    }

    // Initial viz state
    $scope.viz = {
      path: $scope.vizPath,
      vizType: VizType.DeviceVizPreview,
      params: vizService.getVizParams(),
      siteUrlName: server.sessionSiteUrlName(),
      instanceId: vizService.getInstanceId(),
      isExplicitOriginalViz: vizService.getIsExplicitOriginalViz(),
      allowReloadViz: true
    };

    $scope.onVizInitialized = () => $scope.vizInitialized = true;

    this.$scope.devicePickerBarProps = {
      onDeviceTypeClick: (device: DeviceType) => {
        const previewDevice: DeviceType = this.devicePreviewService.changePreviewDevice(device);
        if (previewDevice) {
          this.handleDeviceChange(previewDevice);
        }
      },
      selectedDevice: this.devicePreviewService.getPreviewDevice(),
    };

    this.initializeNavigationToolsPropsOnScope();

    $scope.$watch('viz.isExplicitOriginalViz', (isExplicitOriginalViz: boolean) => {
      vizService.updateExplicitOriginalViz($scope, isExplicitOriginalViz);
    });

    $scope.isTouch = () => UserAgentSupport.isTouch();
  }

  private initializeNavigationToolsPropsOnScope() {
    this.views.getByPath(this.$scope.viz.path)
    .then((viewInfo: IViewDetailInfo) => {
      return this.$q.all({
        dashboards: this.dashboards.getDashboardsForWorkbook(viewInfo.workbook),
        currentViewId: viewInfo.id
      });
    })
    .then(({ dashboards, currentViewId }: { dashboards: IViewInfo[], currentViewId: string }) => {
      this.$scope.devicePickerBarProps = {
        ...this.$scope.devicePickerBarProps,
        navigationToolsProps: this.buildNavigationToolsProps(dashboards, currentViewId)
      };
    });
  }

  // public for testing purposes only
  public buildNavigationToolsProps(dashboardList: IViewInfo[], currentViewId: string) {
    const indexOfCurrentView = dashboardList.findIndex(dashboard => dashboard.id === currentViewId);

    return {
      dashboardList: dashboardList,
      startingDashboardIndex: (indexOfCurrentView !== -1 ? indexOfCurrentView : 0),
      onNewDashboardSelected: (newDashboard: IViewInfo) => {
        this.handleChangedPath(newDashboard.path);
      }
    };
  }

  private handleDeviceChange(device: DeviceType) {
    this.$scope.$apply(() =>
      this.$scope.devicePickerBarProps = _.extend({}, this.$scope.devicePickerBarProps, {
        selectedDevice: device
      })
    );
    this.$scope.viz.reloadViz();
  }

  private handleChangedPath(newPath: string) {
    this.$scope.$apply(() =>
      this.$scope.viz.path = newPath
    );
    this.$scope.viz.reloadViz();
  }

}

Module.instance().controller('VizPreviewCtrl', VizPreviewCtrl);
